import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { PlanningPortalRepository } from "../../repositories";
import { BindLocationWithJobRequest } from "../../domain/requests";

@Injectable({providedIn: 'root'})
export class AddLocationWithJobUsecase implements UseCase<BindLocationWithJobRequest[], boolean> {

  constructor(private planningPortalRepository: PlanningPortalRepository) {
  }

  execute(params: BindLocationWithJobRequest[]): Observable<boolean> {
    return this.planningPortalRepository.addLocationWithJob(params);
  }
}
